import React, { useCallback, useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { useStores } from '../../../store';
import { DynamicPlacementPopover } from '../../../shared/dynamic-placement-popover/dynamic-placement-popover';

interface ApplicationProps {
    applicationsIds: string[];
    isApplicationRule?: boolean;
    maxApplicatoinToDisplay?: number;
}

export const ApplicationCell: React.FC<ApplicationProps> = observer(({ applicationsIds, maxApplicatoinToDisplay = 4, isApplicationRule }) => {
    const { fwVersionStore } = useStores();
    const [applicationsNamesList, setApplicationsNamesList] = useState<string[]>([]);

    useEffect(() => {
        const sortedApplicationsList = applicationsIds.length ? applicationsIds.map(appId => getApplicationDisplayName(appId))
            .sort((a, b) => a.localeCompare(b)) : [];
        setApplicationsNamesList(sortedApplicationsList);
    }, [applicationsIds]);

    const getApplicationDisplayName = useCallback((appId: string) => {
        const defaultApplicationName = fwVersionStore.managedApps?.find(app => app.id === appId)?.displayName;
        return defaultApplicationName ?? appId;
    }, [fwVersionStore]);

    const additionalApplications = applicationsNamesList.length - maxApplicatoinToDisplay;

    const applicationsPopoverContent = applicationsNamesList.length ? applicationsNamesList.map(appId =>
            <div key={appId}>{getApplicationDisplayName(appId)}</div>
    ) : null;

    return applicationsNamesList.length ?
        <DynamicPlacementPopover content={<div className={'expanded-popover'}>{applicationsPopoverContent}</div>} contentHeight={applicationsNamesList.length * 20}>
            <div className={'table-cell-elements-container'}>
                {applicationsNamesList.slice(0, maxApplicatoinToDisplay).map(appId => {
                    const applicationDisplayName = getApplicationDisplayName(appId);
                    return applicationDisplayName && <div key={appId} className={'table-cell-single-element'}>{getApplicationDisplayName(appId)}</div>;
                })}
                {additionalApplications > 0 && <div className={'table-cell-single-element'}>+ {additionalApplications}</div>}
            </div>
        </DynamicPlacementPopover>
        : <>{isApplicationRule ? 'None' : 'Any'}</>;
});